export const ProductCategoryDropDown = [
    {name:'Over Count',value:'overcount'},{name:'Over Count Full Cut',value:'overcountfullcut'},{name:'Over Count Pull veined',value:'overcountpullveined'},{name:'For Weight',value:'forweight'},{name : 'Under Count',value:'undercount'},{name : 'G1',value:'g1'},{name : 'G2',value:'g2'},
    {name : 'Cut',value:'cut'},{name : 'RJ(Rejections)',value:'rj'},{name : 'Damaged',value:'damaged'},{name : 'P1-D',value:'P1_D'},{name : 'P2-D',value:'P2_D'},{name : 'P3-D',value:'P3_D'},{name : 'P4-D',value:'P4_D'},{name : 'P5-D',value:'P5_D'},{name : 'P6-D',value:'P6_D'},{name : 'Red Spot',value:'redspot'},{name : 'Meat',value:'meat'}
]

export enum ProductCategoryEnum {
    overcount = 'Over Count',
    overcountfullcut = 'Over Count Full Cut',
    overcountpullveined = 'Over Count Pull veined',
    undercount = 'Under Count',
    g1 = 'G1',
    g2 = 'G2',
    cut = 'Cut',
    rj = 'RJ(Rejections)',
    forweight = 'For Weight',
    damaged = 'Damaged',
    P1_D = 'P1-D',
    P2_D = 'P2-D',
    P3_D = 'P3-D',
    P4_D = 'P4-D',
    P5_D = 'P5-D',
    P6_D = 'P6-D',
    redspot = 'Red Spot',
    meat = 'Meat',
}
